import React, { useState, useEffect, useRef } from 'react';
import {
  Box, Typography, Grid, Button, useMediaQuery, useTheme, Fade,
  CardMedia,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion'; // Import framer-motion

import IMG_1 from '../../../assets/Landing/l1.webp'

const LandingPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between('340','sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', '740'));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('340'));

  const [fadeIn, setFadeIn] = useState(false);
  const bannerRef = useRef(null);

  // Scroll animations using framer-motion
  const fadeInVariant = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 5 } },
  };

  const slideUpVariant = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 5 } },
  };

  const slideLeftVariant = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 5 } },
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setFadeIn(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      if (bannerRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
      <Box sx={{ width: '100%', position: 'relative', marginTop: '72px', backgroundColor:'#ffffff' }}>
        <Grid item xs={12} sm={12}>
          <Grid 
            container 
            direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
          >
          <Grid 
            item 
            xs={12} 
            md={6}
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center' 
            }}
          >
            <CardMedia
              component="img"
              image={IMG_1} // Replace with your image
              alt="Legal Services"
              style={{ height: '430px', width: '66%' }}
            />
          </Grid>
            <Grid item xs={12} md={6}>
              <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */}
                <Typography 
                  variant="h3" 
                  component="div" 
                  gutterBottom  
                  color="#0067ff"
                  fontWeight={700}
                  sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
                >
                  What Are The Changes In Canada For Tax Season 2023?​
                </Typography>
                <br />
                <br/>
                <Typography variant="subtitle1" color="#252525">
                In 2023, the federal government adjusted the federal income tax brackets by 4.7% to account for inflation and therefore increased the thresholds of each federal income tax bracket. That means that you may pay a lower rate on more of your income because wages did not go up as much as inflation.
                </Typography>
              </CardContent>
            </Grid>
            
          </Grid>
        </Grid>
      </Box>
  );
};

export default LandingPage;
